import React from 'react';

const COLORS = [
    '#10B981', // Emerald 500
    '#3B82F6', // Blue 500
    '#F59E0B', // Amber 500
    '#EF4444', // Red 500
    '#8B5CF6', // Violet 500
    '#EC4899', // Pink 500
    '#06B6D4', // Cyan 500
    '#F97316', // Orange 500
];

const UserAvatar = ({ name, size = 32 }) => {
    const initial = name ? name.charAt(0).toUpperCase() : '?';

    const getColor = (userName) => {
        if (!userName) return COLORS[0];
        let hash = 0;
        for (let i = 0; i < userName.length; i++) {
            hash = userName.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % COLORS.length;
        return COLORS[index];
    };

    const bgColor = getColor(name);

    return (
        <div
            className="flex items-center justify-center rounded-full text-white font-medium shadow-sm border border-white"
            style={{
                backgroundColor: bgColor,
                width: size,
                height: size,
                minWidth: size,
                minHeight: size,
                fontSize: size / 2.2
            }}
            title={name}
        >
            {initial}
        </div>
    );
};

export default UserAvatar;
